import CisionFinancialReportsPage from './CisionFinancialReportsPage';

export default CisionFinancialReportsPage;
